import { CSSObject } from '@emotion/react';

import { colors } from './colors';
import { fonts } from './fonts';

const primaryCommon: CSSObject = {
  color: colors.white,
  background: 'linear-gradient(180deg, #0054AE 0%, #00377C 100%)',
  borderRadius: '4px',
  '&:hover': {
    background:
      // eslint-disable-next-line max-len
      'linear-gradient(338.15deg, #00285A 12.01%, #004A86 83.38%)',
  },
  '&:disabled': {
    background: 'transparent',
    backgroundColor: colors.darkGrey,
  },
};

const secondaryCommon: CSSObject = {
  color: colors.blue3,
  borderRadius: '4px',
  border: `1px solid ${colors.blue3}`,
  '&:hover': {
    color: colors.blue2,
    borderColor: colors.blue2,
  },
  '&:disabled': {
    color: colors.darkGrey,
    borderColor: colors.darkGrey,
  },
};

export const buttons: Record<string, CSSObject> = {
  primary: {
    ...primaryCommon,
    ...fonts.largeLabel,
    padding: '10px 12px',
  },
  primarySmall: {
    ...primaryCommon,
    ...fonts.smallLabel,
    padding: '3px 8px',
  },
  secondary: {
    ...secondaryCommon,
    ...fonts.largeLabel,
    padding: '9px 11px',
  },
  secondarySmall: {
    ...secondaryCommon,
    ...fonts.smallLabel,
    padding: '2px 7px',
  },
} as const;
